export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы в демо-режиме. Балансы и операции — учебные."])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перейти в рабочий кабинет"])}
}